import { render, staticRenderFns } from "./Severity.vue?vue&type=template&id=cdfeb4f6&scoped=true&lang=pug"
import script from "./Severity.vue?vue&type=script&setup=true&lang=ts"
export * from "./Severity.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Severity.vue?vue&type=style&index=0&id=cdfeb4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfeb4f6",
  null
  
)

export default component.exports